import { render, staticRenderFns } from "./autoTable.vue?vue&type=template&id=48ea1868&scoped=true"
import script from "./autoTable.vue?vue&type=script&lang=js"
export * from "./autoTable.vue?vue&type=script&lang=js"
import style0 from "./autoTable.vue?vue&type=style&index=0&id=48ea1868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea1868",
  null
  
)

export default component.exports